import { useState } from 'react';
import { LabsPublishedList, LabsReviewProvider, LabsReviewQueue } from '@ludolio/shared-labs';
import { useUnitsModule } from '../../module-context';
import type { Unit, UnitLabsSettings } from '../../types';
import { UnitLabsCard } from './UnitLabsCard';

interface UnitLabsTabProps {
  unit: Unit;
  settings: UnitLabsSettings;
  onSettingsChanged(settings: UnitLabsSettings): void;
  onProjectsChanged(): void;
}

export function UnitLabsTab({ unit, settings, onSettingsChanged, onProjectsChanged }: UnitLabsTabProps) {
  const { labs } = useUnitsModule();
  const [publishedVersion, setPublishedVersion] = useState(0);
  const refreshPublished = () => setPublishedVersion((version) => version + 1);

  return (
    <div className="space-y-6">
      <UnitLabsCard
        unit={unit}
        settings={settings}
        onSettingsChanged={(next) => {
          onSettingsChanged(next);
          refreshPublished();
        }}
      />
      {labs && (
        <LabsReviewProvider module={labs.review}>
          <section className="space-y-3">
            <h2 className="text-sm font-semibold">Waiting for review</h2>
            <LabsReviewQueue
              scope={labs.scope}
              unitId={unit.id}
              emptyMessage="No projects are waiting for review"
              alignWithPublished
              onDecided={() => {
                onProjectsChanged();
                refreshPublished();
              }}
            />
          </section>
          <section className="space-y-3">
            <h2 className="text-sm font-semibold">Published</h2>
            <LabsPublishedList
              key={publishedVersion}
              scope={labs.scope}
              unitId={unit.id}
              emptyMessage="Nothing is published yet"
              onChanged={onProjectsChanged}
            />
          </section>
        </LabsReviewProvider>
      )}
    </div>
  );
}
